import React, { ReactNode } from "react";
import CloseBtn from "../CloseBtn/CloseBtn";
import "./NotificationCard.scss";

export type NotificationCardProp = {
  title?: string;
  subtitle?: string;
  children?: ReactNode;
  className?: string;
  closeModal?: () => void;
  icon?: ReactNode;
};

const NotificationCard: React.FC<NotificationCardProp> = ({
  title,
  subtitle,
  children,
  className,
  closeModal,
  icon,
}) => {
  return (
    <div
      style={{ padding: "2rem 24px" }}
      className={`notification-card ${className}`}
    >
      {closeModal && (
        <CloseBtn onClose={closeModal} className="notification-card__btn" />
      )}
      {icon}
      <h1>
        {title}
        <br />
        {subtitle}
      </h1>
      {children}
    </div>
  );
};

export default NotificationCard;
